import { APP_PERMISSIONS } from '@exam-management/permissions';
import {
  QSetReviewTaskCreationButton,
  QSetReviewTaskCreationFormProvider,
} from '@exam-management/qset-review-task-creation';
import { QsetReviewStatusFilter, QSetReviewTaskList } from '@exam-management/qset-review-task-list';
import { AddRoundedIcon, Flex, PaperSection } from '@shared/components';
import { PermissionGuard, WithPermission } from '@shared/permissions';

export default function QSetReviewPage() {
  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.TASK.QSET_REVIEW.VIEW}>
      <QSetReviewTaskCreationFormProvider>
        <Flex sx={{ p: (theme) => theme.spacing(6), flexGrow: 1 }}>
          <PaperSection
            title='QSet Review'
            endAdornment={
              <WithPermission
                requiredPermission={[
                  APP_PERMISSIONS.TASK.QSET_REVIEW.CREATE,
                  APP_PERMISSIONS.EXAM.EXAMINATION_COURSE.VIEW,
                  APP_PERMISSIONS.EXAM.QSET.VIEW,
                  APP_PERMISSIONS.SETTING.USER.VIEW,
                ]}
              >
                <QSetReviewTaskCreationButton startIcon={<AddRoundedIcon />}>
                  Create Task
                </QSetReviewTaskCreationButton>
              </WithPermission>
            }
            sx={{ flexGrow: 1 }}
          >
            <Flex
              sx={(theme) => ({
                flexDirection: 'column',
                border: `1px solid ${theme.palette.grey[300]}`,
                borderRadius: theme.shape.rounded(2),
                height: '100%',
                overflow: 'hidden',
                m: theme.spacing(6),
              })}
            >
              <QsetReviewStatusFilter />
              <QSetReviewTaskList />
            </Flex>
          </PaperSection>
        </Flex>
      </QSetReviewTaskCreationFormProvider>
    </PermissionGuard>
  );
}
